import axios from 'axios';

let base = '';


//all content are about for ui-mock

/******************* User && Login Start*******************/
export const requestLogin = params => {
    return axios.post(`${base}/login`, params).then(res => res.data);
};

export const getUserList = params => {
    return axios.get(`${base}/user/list`, {params: params});
};

export const getUserListPage = params => {
    return axios.get(`${base}/user/listpage`, {params: params});
};

export const removeUser = params => {
    return axios.get(`${base}/user/remove`, {params: params});
};

export const batchRemoveUser = params => {
    return axios.get(`${base}/user/batchremove`, {params: params});
};

export const editUser = params => {
    return axios.get(`${base}/user/edit`, {params: params});
};

export const addUser = params => {
    return axios.get(`${base}/user/add`, {params: params});
};
/******************* User && Login End*******************/

/******************* Project Start***********************/
export const requestProjectList = params => {
    return axios.get(`${base}/project/listpage`, params).then(res => res.data);
};

export const requestProjectAssign = params =>{
    return axios.post(`${base}/project/assign`, params).then(res => res.data);
}
export const requestProjectAdd = params =>{
    return axios.post(`${base}/project/add`, params).then(res => res.data);
}

/******************* Project End***********************/



/******************* Employee Start***********************/
export const requestEmployeeList = params => {
    return axios.get(`${base}/employee/listpage`, params).then(res => res.data);
};

/******************* Employee End***********************/



/******************* EmployeeLevelConfig Start***********************/
export const requestELcfgList = params => {
    return axios.get(`${base}/employeecfg/listpage`, params).then(res => res.data);
};
export const requestELcfgAdd = params => {
    return axios.get(`${base}/employeecfg/add`, params).then(res => res.data);
};
/******************* EmployeeLevelConfig End***********************/



/******************* HolidayConfig Start***********************/
export const requestHolidaycfgList = params => {
    return axios.get(`${base}/holiday/listpage`, params).then(res => res.data);
};
export const requestHolidaycfgSet = params => {
    return axios.get(`${base}/holiday/set`, params).then(res => res.data);
};
/******************* HolidayConfig End***********************/



// WEBPACK FOOTER //
// ./src/api/api.js